import {
    awsccp,
    awsccp_pdf,
    rwdd,
    jsads,
    javascript,
    html,
    css,
    java,
    cpp,
    agile,
    aws,
    mysql,
    sql,
    reactjs,
    nextjs,
    nodejs,
    mongodb,
    git,
    ozmo,
    braintrain,
    ubreakifix,
    attentionassistant,
    techblog,
    quotemachine,
    jscalculator,
} from '../assets';

export const navLinks = [
    {
        id: 'about',
        title: 'About'
    },
    {
        id: 'experience',
        title: 'Experience'
    },
    {
      id: 'projects',
      title: 'Projects'
    },
    {
        id: 'contact',
        title: 'Contact'
    },
];

const services = [
  {
    title: "AWS Certified Cloud Practitioner",
    icon: awsccp,
    hasLink: true,
    link: awsccp_pdf
  },
  {
    title: "Responsive Web Design Developer",
    icon: rwdd,
    hasLink: true,
    link: "https://www.freecodecamp.org/certification/ehols001/responsive-web-design"
  },
  {
    title: "JavaScript Algorithms and Data Structures",
    icon: jsads,
    hasLink: true,
    link: "https://www.freecodecamp.org/certification/ehols001/javascript-algorithms-and-data-structures"
  }
];

const skills = [
    {
      name: "Java",
      icon: java,
    },
    {
      name: "C++",
      icon: cpp,
    },
    {
      name: "JavaScript",
      icon: javascript,
    },
    {
      name: "React JS",
      icon: reactjs,
    },
    {
      name: "Next JS",
      icon: nextjs,
    },
    {
      name: "Node JS",
      icon: nodejs,
    },
    {
      name: "SQL",
      icon: sql,
    },
    {
      name: "MySQL",
      icon: mysql,
    },
    {
      name: "MongoDB",
      icon: mongodb,
    },
    {
      name: "HTML 5",
      icon: html,
    },
    {
      name: "CSS 3",
      icon: css,
    },
    {
      name: "AWS",
      icon: aws,
    },
    {
      name: "git",
      icon: git,
    },
    {
      name: "Agile",
      icon: agile,
    },
  ];
  
  const experiences = [
    {
      title: "Software Developer",
      company_name: "BrainTrain, Inc.",
      icon: braintrain,
      iconBg: "linear-gradient(to bottom right, #004264 0%, #002537 100%)",
      date: "January 2025 - Present",
      points: [
        "Architected a fault-tolerant credit card fee optimization platform that routes payments through the HandyAPI BIN Lookup REST service, with caching and resilient handling of timeouts and upstream errors reducing monthly processing costs by 15%.",
        "Engineered JSON-based fee models and business rules powering transaction pricing analysis.",
        "Integrated Deepgram's speech-to-text API for AI dictation, handling continuous data streams and asynchronous processing to minimize latency in internal workflows.",
        "Built a high-volume Python ETL pipeline for marketing data cleansing, reducing a multi-week manual process to under one minute.",
        "Led modernization of legacy VB6 applications to VB.NET and C#, building internal APIs that improved stability and maintainability."
      ],
    },
    {
      title: "IT Technician",
      company_name: "uBreakiFix",
      icon: ubreakifix,
      iconBg: "#fff",
      date: "June 2023 - January 2025",
      points: [
        "Repaired various hardware and managed incoming tickets through an internal ticketing system.",
        "Facilitated ongoing client communication on a regular basis."
      ],
    },
    {
      title: "Senior Content Developer",
      company_name: "Ozmo Inc.",
      icon: ozmo,
      iconBg: "#fff",
      date: "February 2020 - January 2022",
      points: [
        "Progressed from hands-on emulator development to leading cross-functional teams delivering hundreds of interactive self-support emulators driven by JSON and XML content structures.",
        "Orchestrated automated build, test, and deployment workflows using SVN, Jenkins, and an internal CMS within Jira-tracked Agile delivery cycles.",
        "Established QA training and integration testing best practices as a member of the Quality Assurance team, improving release quality and team efficiency.",
        "Communicated regularly with stakeholders to determine and refine project requirements."
      ],
    },
    {
      title: "Mid Content Developer",
      company_name: "Ozmo Inc.",
      icon: ozmo,
      iconBg: "#fff",
      date: "May 2019 - February 2020",
      points: [],
    },
    {
      title: "Associate Content Developer",
      company_name: "Ozmo Inc.",
      icon: ozmo,
      iconBg: "#fff",
      date: "July 2018 - May 2019",
      points: [],
    },
  ];

  const projects = [
    {
      name: "Attention Assistant",
      description:
        "Organizational Java desktop application meant to help adolescents with ADHD stay focused. This application was developed by myself and six others for our senior project.",
      tags: [
        {
          name: "java",
          color: "blue-text-gradient",
        },
        {
          name: "sqlite",
          color: "green-text-gradient",
        },
        {
          name: "opencv",
          color: "pink-text-gradient",
        },
        {
          name: "gradle",
          color: "orange-text-gradient",
        },
        {
          name: "jtest",
          color: "blue-text-gradient",
        },
      ],
      image: attentionassistant,
      project_link: "https://www.cs.odu.edu/~cpi/old/411/coppers22/",
      source_code_link: "https://github.com/ehols001/AttentionAssistant",
    },
    {
      name: "Educational Tech Blog",
      description:
        "A personal tech blog that contains various how-to and informational posts about different technologies.",
      tags: [
        {
          name: "javascript",
          color: "blue-text-gradient",
        },
        {
          name: "react",
          color: "green-text-gradient",
        },
        {
          name: "nextjs",
          color: "pink-text-gradient",
        },
        {
          name: "html",
          color: "orange-text-gradient",
        },
        {
          name: "css",
          color: "blue-text-gradient",
        },
        {
          name: "vercel",
          color: "green-text-gradient",
        },
      ],
      image: techblog,
      project_link: "https://nextjs-blog-ehols001.vercel.app/",
      source_code_link: "https://github.com/ehols001/nextjs-blog",
    },
    {
      name: "Random Quote Machine",
      description:
        "A quote machine using javascript and react that allows you to cycle through random quotes and tweet them directly to your twitter account.",
      tags: [
        {
          name: "javascript",
          color: "blue-text-gradient",
        },
        {
          name: "react",
          color: "green-text-gradient",
        },
        {
          name: "html",
          color: "pink-text-gradient",
        },
        {
          name: "css",
          color: "orange-text-gradient",
        },
      ],
      image: quotemachine,
      project_link: "http://evanholsterrqm.com.s3-website-us-east-1.amazonaws.com/",
      source_code_link: "https://github.com/ehols001/Random-Quote-Machine",
    },
    {
      name: "JavaScript Calculator",
      description:
        "The title says it all for this one; a javascript calculator with basic calculator functionality.",
      tags: [
        {
          name: "javascript",
          color: "blue-text-gradient",
        },
        {
          name: "react",
          color: "green-text-gradient",
        },
        {
          name: "html",
          color: "pink-text-gradient",
        },
        {
          name: "css",
          color: "orange-text-gradient",
        },
      ],
      image: jscalculator,
      project_link: "http://evanholsterjscalc.com.s3-website-us-east-1.amazonaws.com/",
      source_code_link: "https://github.com/ehols001/JavaScript-Calculator",
    },
  ];

  export { services, skills, experiences, projects }